// extracted by mini-css-extract-plugin
export var label = "_dz-1";
export var reminder = "_dz-0";